import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import CategoryCard from '@/components/base/CategoryCard';
import SectionTitle from '@/components/base/SectionTitle';
import CtaSection from '@/components/base/CtaSection';
import { articles, categories } from '@/mocks/articles';

export default function Home() {
  useEffect(() => {
    document.title = '暗网吃瓜 - 实时网红爆料黑料不间断更新 | 暗网吃瓜网站';
  }, []);

  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);
  const latestArticles = articles.slice(0, 8);

  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '暗网吃瓜',
    url: 'http://cccontrol.cn/',
    description: '暗网吃瓜网站是关注网红塌房、明星黑料、博主反差视频的首选平台',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://cccontrol.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[520px] md:h-[640px] flex items-end overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20abstract%20background%20with%20deep%20black%20base%2C%20dark%20red%20radial%20gradient%20overlay%2C%20noise%20texture%20grain%2C%20dark%20web%20node%20patterns%2C%20cyberpunk%20noir%20atmosphere%2C%20ominous%20cinematic%20style%2C%20low%20key%20lighting%2C%20professional%20photography%2C%20mysterious%20and%20dangerous%20vibe%2C%20no%20text%2C%20no%20people&width=1800&height=900&seq=hero-home-2026&orientation=landscape"
              alt="暗网吃瓜 - 实时爆料平台"
              title="暗网吃瓜 - 网红爆料黑料不间断更新"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/60 to-transparent"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-transparent"></div>

            <div className="relative z-10 w-full px-4 md:px-6 pb-16 md:pb-20">
              <div className="max-w-6xl mx-auto">
                <div className="max-w-2xl">
                  <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-50 leading-tight mb-4 tracking-wider">
                    暗网吃瓜
                  </h1>
                  <p className="text-foreground-300 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
                    网红塌房、明星黑料、博主反差视频 —— 实时吃瓜爆料，黑料不间断更新。
                    暗网吃瓜app带来更便捷的吃瓜体验，永久更新入口与最新地址。
                  </p>
                  <div className="flex flex-col sm:flex-row items-start gap-3">
                    <a
                      href="#download"
                      className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500 text-background-950 font-bold text-sm rounded-full hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-fire-fill w-4 h-4 flex items-center justify-center"></i>
                      <span>立即吃瓜</span>
                    </a>
                    <Link
                      to="/category/wanghong"
                      className="inline-flex items-center gap-2 px-7 py-3 bg-background-200/70 backdrop-blur-sm text-foreground-200 font-medium text-sm rounded-full hover:bg-background-300/70 transition-all duration-200 whitespace-nowrap border border-foreground-800/30"
                    >
                      <span>浏览爆料</span>
                      <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Category Quick Links */}
          <section className="w-full px-4 md:px-6 py-10">
            <div className="max-w-6xl mx-auto grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
              {categories.map((cat) => (
                <CategoryCard key={cat.slug} {...cat} />
              ))}
            </div>
          </section>

          {/* Hot Articles - Feature Grid */}
          <section id="hot" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <SectionTitle
                title="热门黑料"
                subtitle="全网最火爆的吃瓜内容，点击量爆表的劲爆话题"
              />
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {hotArticles.map((article, index) => (
                  <ArticleCard
                    key={article.id}
                    article={article}
                    variant={index === 0 ? 'large' : 'default'}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section id="latest" className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-6xl mx-auto">
              <SectionTitle
                title="最新爆料"
                subtitle="实时更新的吃瓜资讯，不错过任何一个大瓜"
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} variant="compact" />
                ))}
              </div>
              <div className="text-center mt-8">
                <Link
                  to="/category/wanghong"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-200 text-foreground-300 text-sm rounded-full hover:bg-background-300 hover:text-foreground-100 transition-all duration-200 whitespace-nowrap"
                >
                  <span>查看更多爆料</span>
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>
          </section>

          {/* Download CTA */}
          <section id="download" className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <div className="bg-background-200 rounded-3xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 border border-background-300/30">
                <div className="flex-1 text-center lg:text-left">
                  <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3 tracking-wider">
                    获取暗网吃瓜App
                  </h2>
                  <p className="text-foreground-400 text-sm mb-6 max-w-md">
                    下载暗网吃瓜app，第一时间接收推送通知，从此吃瓜快人一步。
                    支持iOS和Android双平台，永久免费更新。
                  </p>
                  <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                    <a
                      href="#"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 text-background-950 font-medium text-sm rounded-full hover:bg-foreground-200 transition-all whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-apple-fill w-4 h-4 flex items-center justify-center"></i>
                      <span>App Store 下载</span>
                    </a>
                    <a
                      href="#"
                      className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-50 text-background-950 font-medium text-sm rounded-full hover:bg-foreground-200 transition-all whitespace-nowrap cursor-pointer"
                    >
                      <i className="ri-google-play-fill w-4 h-4 flex items-center justify-center"></i>
                      <span>Google Play 下载</span>
                    </a>
                  </div>
                </div>
                <div className="flex gap-4 shrink-0">
                  <div className="w-32 h-56 rounded-2xl bg-background-300 overflow-hidden border border-background-400/30">
                    <div className="w-full h-full bg-gradient-to-b from-primary-500/20 to-background-300 flex items-center justify-center">
                      <i className="ri-smartphone-line text-foreground-600 text-4xl w-10 h-10 flex items-center justify-center"></i>
                    </div>
                  </div>
                  <div className="w-32 h-56 rounded-2xl bg-background-300 overflow-hidden border border-background-400/30 mt-4">
                    <div className="w-full h-full bg-gradient-to-b from-accent-500/10 to-background-300 flex items-center justify-center">
                      <i className="ri-smartphone-line text-foreground-600 text-4xl w-10 h-10 flex items-center justify-center"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}